import { createListenerMiddleware } from '@reduxjs/toolkit'
import { logger } from '@axilon-apps/libs-ui-core'

import { getPlatformServices } from '../../../platform'
import AuthenticationStorage from '../../../shared/core/services/authentication-token'
import { authenticationLogout } from '../../actions/authentication-actions'
import { getTokenSelector } from '../../slices/authentication-slice'
import type { IdentityRootState } from '../../types/state'
import api from '../../api'

const authenticationLogoutListener = createListenerMiddleware<IdentityRootState>()

authenticationLogoutListener.startListening({
  actionCreator: authenticationLogout,
  async effect({ payload: { skipSessionDelete = false } }, { dispatch, getState }) {
    const token = getTokenSelector(getState())
    if (token && !skipSessionDelete) {
      const { data, error } = await dispatch(api.endpoints.logout.initiate(token.id))
      if (error) {
        logger.error('Failed to delete session from API server', { data, error })
      }
    }
    // Clear OIDC session (no-op on electron, removes OIDC user on web)
    try {
      await getPlatformServices().windowsAuth.signout()
    } catch (err) {
      logger.warn('Failed to sign out', { error: err })
    }
    AuthenticationStorage.clear()
    window.location.reload()
  }
})

export default authenticationLogoutListener
